import {
  CodeResponse,
  useGoogleLogin as useGoogleLogin2,
} from "@react-oauth/google";
import axios from "axios";
import { GOOGLE_CLIENTID, SECRET_GOOGLE_CLIENTID } from "config";
import qs from "qs";
import { useEffect, useState } from "react";
import useLoginV3 from "./useLoginV3";

export default function useGoogleLoginV3() {
  const clientId = GOOGLE_CLIENTID;
  const secret_clientId = SECRET_GOOGLE_CLIENTID;
  const origin = window.location.origin;

  const [idToken, setIdToken] = useState<string>();
  const [isLoadingToken, setIsLoadingToken] = useState(false);

  const { login, isLoading: isLoadingLogin } = useLoginV3({
    url: `/user/v2/login`,
    idToken: idToken!!,
    type: "google",
  });

  useEffect(() => {
    if (idToken) {
      login();
    }
  }, [idToken]);

  const isLoading = isLoadingToken || isLoadingLogin;

  const getIdToken = async (
    code: string,
    clientId: string,
    secret_clientId: string
  ) => {
    setIsLoadingToken(true);
    try {
      const response = await axios.post(
        `https://oauth2.googleapis.com/token`,
        qs.stringify({
          code: code,
          client_id: clientId,
          client_secret: secret_clientId,
          redirect_uri: origin,
          grant_type: "authorization_code",
        })
      );
      if (response) {
        const idToken = response.data.id_token;
        setIdToken(idToken);
      }
    } catch (error) {
      console.error("result", error);
      setIsLoadingToken(false);
    }
  };

  const getCredentialCustom = (codeResponse: CodeResponse) => {
    getIdToken(codeResponse.code, clientId, secret_clientId);
  };

  const handleGoogleLogin = useGoogleLogin2({
    onSuccess: (codeResponse) => getCredentialCustom(codeResponse),
    flow: "auth-code",
    ux_mode: "popup",
    redirect_uri: origin,
  });

  return { handleGoogleLogin, isLoading };
}
